import { IntegrationTransaction } from "../../types/integrationTransaction";

export class IntegrationTransactionDto {
    id: string;
    amount: number;
    date: string;
    bankDescription: string;
    financialTransactionId: number | null;
    integrationAccountId: string;

    constructor(integrationTransaction: IntegrationTransaction) {
        this.id = integrationTransaction.id;
        this.amount = integrationTransaction.amount;
        this.date = integrationTransaction.date.toISOString();
        this.bankDescription = integrationTransaction.bankDescription;
        this.financialTransactionId =
            integrationTransaction.financialTransactionId;
        this.integrationAccountId = integrationTransaction.integrationAccountId;
    }

    static deserialize(dto: IntegrationTransactionDto): IntegrationTransaction {
        return {
            ...dto,
            date: new Date(dto.date),
        };
    }
}
